import { initializeApp } from 'firebase/app';
import { getDatabase, ref, set, get, push, onValue, off, remove, update, onDisconnect, serverTimestamp } from 'firebase/database';
import {
  getAuth,
  signInWithPopup,
  signInWithCustomToken,
  getAdditionalUserInfo,
  TwitterAuthProvider,
  signOut as firebaseSignOut,
  onAuthStateChanged,
  type User as FirebaseUser
} from 'firebase/auth';
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit,
  addDoc,
  onSnapshot,
  startAfter,
  type QueryDocumentSnapshot,
  type DocumentData,
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const auth = getAuth(app);
const firestore = getFirestore(app);

// Auth providers
const twitterProvider = new TwitterAuthProvider();

// Firestore types (replacing Supabase types)
export interface Profile {
  id: string;
  username: string;
  email: string;
  avatar_url?: string;
  created_at: string;
  allow_messages: boolean;
  elo_rating?: number;
  is_admin?: boolean;
  is_banned?: boolean;
  ban_reason?: string;
  banned_at?: string;
}

export interface Friendship {
  id?: string;
  user_id: string;
  friend_id: string;
  status: 'pending' | 'accepted' | 'rejected';
  created_at: string;
}

export interface GameResult {
  id?: string;
  player1_id: string;
  player2_id: string;
  game_type: string;
  winner_id?: string;
  is_draw: boolean;
  created_at: string;
}

export {
  // Realtime Database
  database,
  ref,
  set,
  get,
  push,
  onValue,
  off,
  remove,
  update,
  onDisconnect,
  serverTimestamp,
  // Auth
  auth,
  signInWithPopup,
  signInWithCustomToken,
  getAdditionalUserInfo,
  twitterProvider,
  firebaseSignOut,
  onAuthStateChanged,
  // Firestore
  firestore,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit,
  addDoc,
  onSnapshot,
  startAfter,
};

export type { FirebaseUser, QueryDocumentSnapshot, DocumentData };
